<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-title>{{ "ORDERS.ORDER_DETAILS" | translate }}</ion-title>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="main/orders" [text]="'COMMON.BACK' | translate" />
    </ion-buttons>
  </ion-toolbar>
  <ion-toolbar>
    <ion-segment [value]="tab()" (ionChange)="onSegmentChanged($event)" class="max-w-[650px] mx-auto">
      <ion-segment-button value="details">
        <ion-label>{{ "ORDERS.DETAILS" | translate }}</ion-label>
      </ion-segment-button>
      <ion-segment-button value="chat">
        <ion-label>{{ "ORDERS.CONVERSATION" | translate }}</ion-label>
      </ion-segment-button>
    </ion-segment>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">
  @switch (store.getOrderByIdState().type) {
    @case ("loading") {
      <mtjr-loading />
    }
    @case ("error") {
      <mtjr-error [failure]="store.getOrderByIdFailure()" />
    }
    @case ("success") {
      <div class="flex justify-center h-full">
        @if (store.order(); as order) {
          @if (store.subOrder(); as subOrder) {
            @if (tab() === "details") {
              <div class="pt-2 md:p-6 w-full max-w-[750px]">
                <ion-card class="mx-4 my-2 border-none p-4 pb-2">
                  <div class="mb-1 flex items-center">
                    <div class="flex flex-1 flex-col">
                      <ion-text>{{ "ORDERS.ORDER_ID" | translate }}</ion-text>
                      <ion-text color="dark" class="text-lg">{{ order.orderNo }}</ion-text>
                    </div>
                    <!-- <ion-icon class="mx-2 text-lg" [name]="order.paymentMethod"></ion-icon>
                    <ion-text color="dark" class="font-bold">
                      {{ "ENUMS.PaymentMethod." + order.paymentMethod | translate }}
                    </ion-text> -->
                    @if (!order.external) {
                      <ion-icon class="mx-2 text-lg" [name]="order.paymentMethod"></ion-icon>
                      <ion-text color="dark" class="font-bold">
                        {{ "ENUMS.PaymentMethod." + order.paymentMethod | translate }}
                      </ion-text>
                    } @else {
                      <ion-icon class="mx-2 text-lg" name="pencil-outline"></ion-icon>
                      <ion-text color="dark" class="font-bold">
                        {{ "ORDERS.EXTERNAL_ORDER" | translate }}
                      </ion-text>
                    }
                    <div class="bg-medium/30 h-4 w-[1px] mx-4"></div>
                    <ion-text color="primary" class="text-lg font-bold">{{ subOrder.total | vxCurrency }}</ion-text>
                  </div>
                  <div class="bg-light h-[1px] w-full"></div>
                  <div class="mt-2 mb-2 flex items-center">
                    <ion-text color="medium" class="me-2 text-sm">{{ "COMMON.STATUS" | translate }}</ion-text>
                    <mtjr-order-status-text class="flex-1" [status]="subOrder.status"></mtjr-order-status-text>
                    <ion-text color="medium" class="me-2">{{ "COMMON.DATE" | translate }}:</ion-text>
                    <ion-text color="medium">{{ order.createdAt | date: "yyyy-MM-dd" }}</ion-text>
                  </div>
                  @if (subOrder.status === "canceled") {
                    <div class="mt-3 mb-2 flex items-center">
                      <ion-text color="medium" class="me-2">{{ "COMMON.REASON" | translate }}:</ion-text>
                      <ion-text color="medium" class="flex-1">
                        {{ { en: subOrder.notesEn ?? undefined, ar: subOrder.notesAr ?? undefined } | langSelect }}
                      </ion-text>
                    </div>
                  }

                  @if (subOrder.status !== "delivered" && subOrder.status !== "canceled") {
                    <div class="bg-medium/20 mb-2 mt-3 h-[1px] w-full"></div>
                    <div class="flex justify-start">
                      <ion-button color="danger" [routerLink]="'cancel'" routerDirection="forward">
                        {{ "ORDERS.MARK_AS_CANCELED" | translate }}
                      </ion-button>

                      <div class="mx-1"></div>
                      <div class="flex flex-1 max-w-[220px]">
                        @switch (subOrder.status) {
                          @case ("processing") {
                            <mtjr-submit-button
                              [state]="store.markOrderAsReadyForShippingState()"
                              type="button"
                              color="primary"
                              [label]="'ORDERS.MARK_AS_READY_FOR_SHIPPING' | translate"
                              (click)="markShipped(order)"
                            />
                          }
                          @case ("readyForProcessing") {
                            <mtjr-submit-button
                              [state]="store.markOrderAsProcessingState()"
                              type="button"
                              color="warning"
                              [label]="'ORDERS.MARK_AS_PROCESSING' | translate"
                              (click)="markProcessing(order)"
                            />
                            <div class="mx-1"></div>
                            <mtjr-submit-button
                              [state]="store.markOrderAsReadyForShippingState()"
                              type="button"
                              color="primary"
                              [label]="'ORDERS.MARK_AS_READY_FOR_SHIPPING' | translate"
                              (click)="markShipped(order)"
                            />
                          }
                          @case ("shipped") {
                            <mtjr-submit-button
                              [state]="store.markOrderAsProcessingState()"
                              type="button"
                              color="success"
                              [label]="'ORDERS.MARK_AS_PROCESSING' | translate"
                              (click)="markAsProcessing(order)"
                            />
                          }
                        }
                      </div>
                    </div>
                  }

                  <mtjr-error-bar [failure]="store.markOrderAsProcessingFailure()" />
                  <mtjr-error-bar [failure]="store.markOrderAsReadyForShippingFailure()" />
                  <mtjr-error-bar [failure]="store.markOrderAsProcessingFailure()" />
                </ion-card>

                @if (order.notes) {
                  <ion-card class="mx-4 my-4 p-4">
                    <ion-text color="medium" class="text-sm font-semibold">{{ "ORDERS.NOTES" | translate }}</ion-text>
                    <ion-text color="dark" class="mt-2 block">{{ order.notes }}</ion-text>
                  </ion-card>
                }

                <div class="mt-6">
                  <ion-text class="px-8 text-lg">{{ "ORDERS.PRODUCT_LIST" | translate }}</ion-text>
                </div>

                <ion-card class="mx-4 my-2 px-3">
                  @for (item of subOrder.orderProducts; track $index) {
                    <div class="my-3 pe-3">
                      <div class="mb-0.5 flex">
                        <mtjr-img
                          [src]="productImage(item)"
                          [imgClass]="
                            'w-20 aspect-square rounded-lg me-4 border border-solid border-medium/30 ' +
                            (item.productType === 'digital' ? 'object-contain' : 'object-cover')
                          "
                          alt="{{ 'PRODUCTS.PRODUCT_IMAGE' | translate }}"
                        />

                        <div class="mt-1 flex flex-1 flex-col">
                          <div class="flex flex-wrap justify-end items-center gap-2">
                            <ion-text class="me-auto font-bold">
                              {{ item.productName }}
                            </ion-text>

                            @for (attr of variationAttributes(item); track $index) {
                              @if (attr.type !== "color") {
                                <div
                                  class="border-primary text-primary bg-primary/10 min-w-6 rounded-full border-[1.5px] border-solid px-2 text-center"
                                >
                                  @if (item.productType === "digital") {
                                    <ion-label color="dark" class="my-1 me-2 line-clamp-1 select-none text-white">
                                      {{ attr.label }} {{ "COMMON.CURRENCY_SYMBOL" | translate }}
                                    </ion-label>
                                  } @else {
                                    <ion-label class="text-sm">
                                      {{ "ATTRIBUTE." + attr.typeLabel.toUpperCase() | translate }} - {{ attr.label }}
                                    </ion-label>
                                  }
                                </div>
                              } @else {
                                <div
                                  fill="clear"
                                  class="border-medium !m-0 flex size-6 items-center justify-center rounded-full border-2 border-solid !p-0 text-white"
                                  [ngStyle]="{
                                    'background-color': attr.key,
                                  }"
                                ></div>
                              }
                            }
                          </div>

                          <div class="flex flex-wrap">
                            <ion-text color="primary" class="text-md me-2 break-keep">
                              {{ item.finalPrice | vxCurrency }}
                            </ion-text>
                          </div>
                          <ion-text class="mt-2 font-bold">
                            {{ item.quantity }} {{ "PRODUCTS.ITEMS" | translate }}
                          </ion-text>
                        </div>
                      </div>
                    </div>
                    <div class="bg-light ms-24 h-[1px] w-full"></div>
                  }
                </ion-card>
                <ion-card class="mx-4 my-4 p-4">
                  <!-- <div class="flex items-center">
                    <ion-text color="medium" class="flex-1">{{ "ORDERS.PAYMENT_METHOD" | translate }}</ion-text>
                    <ion-icon class="mx-2 text-lg" [name]="order.paymentMethod"></ion-icon>
                    <ion-text color="dark" class="font-bold">
                      {{ "ENUMS.PaymentMethod." + order.paymentMethod | translate }}
                    </ion-text>
                  </div> -->
                  <!-- <div class="bg-light h-[1px] w-full my-4"></div> -->
                  <div class="flex">
                    <ion-text color="medium" class="flex-1">{{ "ORDERS.SUB_TOTAL" | translate }}</ion-text>
                    <ion-text color="dark" class="font-bold">{{ subOrder.subTotal | vxCurrency }}</ion-text>
                  </div>
                  <div class="bg-light h-[1px] w-full my-4"></div>
                  <div class="mt-2 flex">
                    <ion-text color="medium" class="flex-1">{{ "ORDERS.TOTAL" | translate }}</ion-text>
                    <ion-text color="dark" class="font-bold">{{ subOrder.total | vxCurrency }}</ion-text>
                  </div>
                </ion-card>
              </div>
            } @else {
              <div class="flex flex-col h-full md:h-auto w-full max-w-[750px]">
                <div
                  class="sticky top-0 z-10 py-2 flex items-start whitespace-nowrap overflow-x-auto min-h-fit shadow-sm scrollbar-none bg-transparent/20"
                >
                  @for (item of subOrder.orderProducts; track $index) {
                    <div
                      class="flex flex-shrink-0 items-center ps-1 pe-3 py-1 bg-light rounded-lg whitespace-nowrap me-2"
                    >
                      <mtjr-img
                        [src]="productImage(item)"
                        [imgClass]="
                          'w-8 aspect-square rounded-lg me-4 border border-solid border-medium/30 ' +
                          (item.productType === 'digital' ? 'object-contain' : 'object-cover')
                        "
                        alt="{{ 'PRODUCTS.PRODUCT_IMAGE' | translate }}"
                      />
                      <ion-text class="text-sm text-medium">{{ item.productName }}</ion-text>
                    </div>
                  }
                </div>
                <mtjr-orders-chat class="flex-1 pt-2" [order]="order" [subOrder]="subOrder" />
              </div>
            }
          }
        }
      </div>
    }
  }
</ion-content>
